import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Layout from '../components/layout.component';
import useAuthStore from '../stores/auth.store';

function RequireAuth() {
  const location = useLocation();
  const { token } = useAuthStore();

  const accessToken = token || localStorage.getItem('accessToken'); // LocalStorage'dan yedek al

  if (!accessToken)
    return <Navigate to="/login" state={{ from: location }} replace />;

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

export default RequireAuth;
